/**
 * Miasta do wyboru lokalizacji. Wspolrzedne to srodki miast (wiedza powszechna),
 * uzywane wylacznie do wskazania najblizszego miasta po udostepnieniu lokalizacji.
 * NIE sluza do liczenia odleglosci do konkretnej placowki.
 */
export type Miasto = { nazwa: string; lat: number; lon: number };

export const miasta: Miasto[] = [
  { nazwa: "Warszawa", lat: 52.2297, lon: 21.0122 },
  { nazwa: "Kraków", lat: 50.0647, lon: 19.945 },
  { nazwa: "Łódź", lat: 51.7592, lon: 19.4559 },
  { nazwa: "Wrocław", lat: 51.1079, lon: 17.0385 },
  { nazwa: "Poznań", lat: 52.4064, lon: 16.9252 },
  { nazwa: "Gdańsk", lat: 54.352, lon: 18.6466 },
  { nazwa: "Szczecin", lat: 53.4285, lon: 14.5528 },
  { nazwa: "Bydgoszcz", lat: 53.1235, lon: 18.0084 },
  { nazwa: "Lublin", lat: 51.2465, lon: 22.5684 },
  { nazwa: "Białystok", lat: 53.1325, lon: 23.1688 },
  { nazwa: "Katowice", lat: 50.2649, lon: 19.0238 },
  { nazwa: "Gdynia", lat: 54.5189, lon: 18.5305 },
  { nazwa: "Częstochowa", lat: 50.8118, lon: 19.1203 },
  { nazwa: "Radom", lat: 51.4027, lon: 21.1471 },
  { nazwa: "Rzeszów", lat: 50.0412, lon: 21.999 },
  { nazwa: "Toruń", lat: 53.0138, lon: 18.5984 },
  { nazwa: "Kielce", lat: 50.8661, lon: 20.6286 },
  { nazwa: "Olsztyn", lat: 53.7784, lon: 20.4801 },
];

/** Odleglosc po wielkim kole, w kilometrach. */
export function odleglosc(aLat: number, aLon: number, bLat: number, bLon: number) {
  const R = 6371;
  const r = (x: number) => (x * Math.PI) / 180;
  const dLat = r(bLat - aLat), dLon = r(bLon - aLon);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(r(aLat)) * Math.cos(r(bLat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function najblizszeMiasto(lat: number, lon: number): Miasto {
  return miasta.reduce((naj, m) =>
    odleglosc(lat, lon, m.lat, m.lon) < odleglosc(lat, lon, naj.lat, naj.lon) ? m : naj
  );
}
